import { render, staticRenderFns } from "./historicoPagamento-pdf.vue?vue&type=template&id=21eb13f4&scoped=true&"
import script from "./historicoPagamento-pdf.vue?vue&type=script&lang=js&"
export * from "./historicoPagamento-pdf.vue?vue&type=script&lang=js&"
import style0 from "./historicoPagamento-pdf.vue?vue&type=style&index=0&id=21eb13f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eb13f4",
  null
  
)

export default component.exports